import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import clsx from "clsx";
import {
  HomeIcon,
  TruckIcon,
  UserGroupIcon,
  Cog6ToothIcon,
  ArrowLeftEndOnRectangleIcon,
} from "@heroicons/react/24/outline";
import {
  HomeIcon as HomeIconSolid,
  TruckIcon as TruckIconSolid,
  UserGroupIcon as UserGroupIconSolid,
  Cog6ToothIcon as Cog6ToothIconSolid,
} from "@heroicons/react/24/solid";
import styles from "../../../app/styles/Aside.module.scss";

const ICON_MAP = {
  home: { outline: HomeIcon, solid: HomeIconSolid },
  directions_car: { outline: TruckIcon, solid: TruckIconSolid },
  user_group: { outline: UserGroupIcon, solid: UserGroupIconSolid },
  manufacturing: { outline: Cog6ToothIcon, solid: Cog6ToothIconSolid },
};

function MenuIcon({ icon, active }) {
  const pair = ICON_MAP[icon] || ICON_MAP.home;
  const Icon = active ? pair.solid : pair.outline;

  return <Icon className={styles.menuIcon} />;
}

function isItemActive(item, pathname) {
  if (!item.page) {
    return false;
  }

  const segment = pathname.split("/")[1] || "";
  const is_inicio = item.page === "inicio" && (pathname === "/" || pathname === "/inicio");

  return segment === item.page || is_inicio;
}

class Menu extends React.Component {
  render() {
    const { menuConfig, location } = this.props;
    const pathname = location.pathname.split(/[?#]/)[0];
    const items = menuConfig.aside.items || [];

    return (
      <div className={styles.menu}>
        <ul className={styles.menuList}>
          {items.map((item, index) => {
            const active = isItemActive(item, pathname);
            const IconComponent = (
              <MenuIcon icon={item.icon} active={active} />
            );

            return (
              <li key={`menu-item-${index}`}>
                <Link
                  to={`/${item.page}`}
                  className={clsx(
                    styles.menuContainer,
                    active && styles.menuContainerActive
                  )}
                >
                  {IconComponent}
                  <span className={styles.menuLabel}>{item.title}</span>
                </Link>
              </li>
            );
          })}
        </ul>
        <div className={styles.menuFooter}>
          <Link
            to="/logout"
            className={clsx(
              styles.menuContainer,
              pathname === "/logout" && styles.menuContainerActive
            )}
          >
            <ArrowLeftEndOnRectangleIcon className={styles.menuIcon} />
            <span className={styles.menuLabel}>Sair</span>
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  menuConfig: store.builder.menuConfig,
});

export default withRouter(connect(mapStateToProps)(Menu));
